module.exports = __webpack_public_path__ + "img/clock_yellow.f55ca052.svg";